import React, { useState, useEffect } from 'react';
import SubscriptionPage from './pages/SubscriptionPage';
import WelcomePage from './pages/WelcomePage';
import GreekTextDisplay1 from './components/GreekTextDisplay1';
import GreekTextDisplay from './components/GreekTextDisplay';
import ResourcesPage, { Alphabet, Vocab } from './pages/ResourcesPage';
import { BrowserRouter as Router, Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import WordInfoGridPage from './pages/WordInfoGridPage';
import dictionary from './components/dictionaryData';
import VideoTransition from './pages/VideoTransition';
import GameComponent from './pages/GameComponent';
import TrophyRoom from './pages/TrophyRoom';
import StoreRoom from './pages/StoreRoom';
import Layout from './components/Layout'
import './App.css'
import { GameProvider } from './context/GameContext';

const AppContent: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isSubscriptionPage = location.pathname === '/subscription';

  const getBackgroundClass = () => {
    switch (location.pathname) {
      case '/subscription':
        return {
          backgroundImage: "url('/images/greecesky.png')",
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        };
      default:
        return {}; // No background image for other pages, including the root path
    }
  };

  //potential not using
  const handleGetStarted = () => {
    navigate('/map');//gives the button the power to actually navigate
  };
  
  // Define which paths should have the navbar
  const shouldShowNavBar = [
    '/greek-text',  // your reading passage page
    '/game1',       // your game page
    '/store',       // store room
    '/trophy-room'  // trophy room
  ].includes(location.pathname);

  return (
    <div className="flex flex-col min-h-screen">
      {isSubscriptionPage && (
        <header className="bg-terracotta text-warm-cream pt-4 pb-1 px-4 shadow-md">
          <h1 className="text-2xl font-bold font-cinzel">Epikon: Greek Mythology Learning</h1>
        </header>
      )}
      {shouldShowNavBar ? (
        <Layout>
        <Routes>
          <Route path="/greek-text" element={<GreekTextDisplay />} />
          <Route path="/game1" element={<GameComponent />} />
          <Route path="/store" element={<StoreRoom />} /> {/* Removed currentCoins prop */}
          <Route path="/trophy-room" element={<TrophyRoom />} />
        </Routes>
      </Layout>

      ) : (
      <main
        className="flex-grow"
        style={getBackgroundClass()}
      >
        <Routes>
          <Route path="/" element={<WelcomePage onGetStarted={handleGetStarted} />} />
          <Route path="/subscription" element={
            <div className="container mx-auto py-8">
              <SubscriptionPage />
            </div>
          } />
          <Route path="/greek-text" element={<GreekTextDisplay />} />
          <Route path="/game1" element={<GameComponent />} />
          <Route path="/greek-text-1" element={<GreekTextDisplay1 />} />
          <Route path="/resources" element={<ResourcesPage />} />
          <Route path="/vocabulary" element={<Vocab />} />
          <Route path="/alphabet" element={<Alphabet />} />
          <Route path="/map" element={<VideoTransition />} />
          <Route path="/dictionary" element={<WordInfoGridPage dictionary={dictionary} />} />
          <Route path="/trophy-room" element={<TrophyRoom />} />
          <Route path="/store" element={<StoreRoom />} /> {/* Removed currentCoins prop */}
        </Routes>
      </main>
      )}
      {isSubscriptionPage && (
        <footer className="bg-terracotta text-warm-cream p-1 text-center">
          <p className="font-cinzel">&copy; {new Date().getFullYear()} Epikon Learning. All rights reserved.</p>
        </footer>
      )}
    </div>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <GameProvider>
        <AppContent />
      </GameProvider>
    </Router>
  );
};

export default App;